// Basic
import PropTypes from 'prop-types';
// Components
import Entity from '@/common-utils/components/renders/entity/Entity';
import Icon from '@/common-utils/components/renders/icon/Icon';
import TooltipHelper from '@/common-utils/components/renders/tooltip/TooltipHelper';
// Common
import { findApplicationFromCode, namespace } from '../../enums/ItpRegex';
import ICONS from '@/common-utils/enums/icons';
// Lang
import { nsContract } from '@/app/i18n/namespaces';

/**
 * @param root0
 * @param root0.applicationCode
 * @param root0.shouldNotSendMail
 * @param root0.unknownApplicationMailContent
 * @returns {JSX} RenderApplication
 */
function RenderApplication({ applicationCode, shouldNotSendMail = false, unknownApplicationMailContent = undefined }) {

    // Constants
    const application = findApplicationFromCode(applicationCode);
    const applicationName = application?.name;

    // Fonctions
    const sendMail = () => {
        if (unknownApplicationMailContent && !shouldNotSendMail) {
            window.location.href = unknownApplicationMailContent;
        }
    };

    return (
        <>
            {application &&
                <>
                    {!application.logo &&
                        // Application without logo
                        <div
                            className='labelApplicationAsLogo'
                            title={applicationName}>
                            <Entity entity={application.entity} namespace={namespace} />
                        </div>
                    }
                    {application.logo &&
                        // RenderApplication with logo
                        <div className='flex flex-col items-center'>
                            <div className='max-w-20 max-h-10'>
                                <img alt=''
                                    src={application.logo}
                                    className='max-h-10 w-auto object-contain'
                                    title={applicationName} />
                            </div>
                            <small className='labelApplication text-center whitespace-nowrap'
                                title={applicationName}>
                                <Entity entity={application.entity} namespace={namespace} />
                            </small>
                        </div>
                    }
                </>
            }
            {!application &&
                // No application found
                <div>
                    <div
                        className='renderPosTerminalApplication'>
                        <TooltipHelper
                            asChild
                            trigger={
                                <button
                                    type='button'
                                    onClick={sendMail}
                                    className='flex items-center bg-transparent border-none p-0 m-0 cursor-pointer focus:outline-none'
                                    disabled={shouldNotSendMail}
                                >
                                    <Icon
                                        className='iconUnknown'
                                        icon={ICONS.UNKNOWN}
                                    />
                                    <Icon
                                        icon={ICONS.ARROW_RIGHT}
                                    />
                                    <Icon
                                        className={shouldNotSendMail ? 'iconMail' : 'iconMail clickable'}
                                        icon={ICONS.CONTACT_MAIL}
                                    />
                                </button>
                            }
                            content={<Entity entity={shouldNotSendMail ? '' : 'tooltips.mail_to_unknown_application'} namespace={nsContract} />}
                        />
                    </div>
                    <small className='labelApplication'>
                        <Entity entity='application.UNKNOWN_APPLICATION' namespace={namespace} />
                    </small>
                </div >
            }
        </>
    );
}

RenderApplication.propTypes = {
    applicationCode: PropTypes.string,
    shouldNotSendMail: PropTypes.bool,
    unknownApplicationMailContent: PropTypes.string
};


export default RenderApplication;